<template>
  <span class="float-right text-no-wrap">
    Handling
    <v-tooltip class="mr-0" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="primary" v-bind="attrs" v-on="on" small>
          mdi-help-circle-outline
        </v-icon>
      </template>
      <span
      >This handling fee is applied to all purchases of less than 300oz of
        silver, or less than 10 oz of Gold, Platinum or Palladium.</span
      >
    </v-tooltip>
  </span>
</template>

<script>
export default {}
</script>
